import "core-js/modules/es.parse-float.js";
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/img/storehouse.png';
import _imports_1 from '@/assets/img/storehouse-safe.png';
import _imports_2 from '@/assets/img/storehouse-bottom.png';
import _imports_3 from '@/assets/img/storehouse-bg.png';
import _imports_4 from '@/assets/img/storehouse-top.png';
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-11bbda94"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "stock-aggregate-level"
};
var _hoisted_2 = {
  key: 0,
  class: "container"
};
var _hoisted_3 = {
  class: "img-box"
};
var _hoisted_4 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "main"
  }, null, -1);
});
var _hoisted_5 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    class: "bottom"
  }, null, -1);
});
var _hoisted_6 = {
  class: "info"
};
var _hoisted_7 = {
  class: "title"
};
var _hoisted_8 = {
  class: "desc-info"
};
var _hoisted_9 = {
  class: "value"
};
var _hoisted_10 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", null, "当前料位", -1);
});
var _hoisted_11 = {
  class: "value warn"
};
var _hoisted_12 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", null, "安全库位", -1);
});
var _hoisted_13 = {
  class: "value"
};
var _hoisted_14 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", null, "可下单吨位", -1);
});
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_c_no_data = _resolveComponent("c-no-data");
  var _component_Overlay = _resolveComponent("Overlay");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_ctx.stockData.length ? (_openBlock(), _createElementBlock("ul", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stockData, function (item, index) {
    return _openBlock(), _createElementBlock("li", {
      key: index
    }, [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("img", {
      src: _imports_1,
      class: "safe",
      style: _normalizeStyle({
        bottom: "".concat(item.safeRatio, "% ")
      })
    }, null, 4), _hoisted_5, _createElementVNode("img", {
      src: _imports_3,
      class: "bg",
      style: _normalizeStyle({
        height: "".concat(item.ratio, "%")
      })
    }, null, 4), _createElementVNode("img", {
      src: _imports_4,
      class: "top",
      style: _normalizeStyle({
        top: "".concat(100 - parseFloat(item.ratio), "%"),
        'margin-top': parseFloat(item.ratio) === 0 ? '0px' : ''
      })
    }, null, 4)]), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, _toDisplayString(item.name), 1), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", null, [_createElementVNode("div", _hoisted_9, _toDisplayString(item.stone_value) + "m", 1), _hoisted_10]), _createElementVNode("div", null, [_createElementVNode("div", _hoisted_11, _toDisplayString(item.safe_level) + "m", 1), _hoisted_12]), _createElementVNode("div", null, [_createElementVNode("div", _hoisted_13, _toDisplayString(item.usable_weight) + "t", 1), _hoisted_14])])])]);
  }), 128))])) : !_ctx.firstLoad ? (_openBlock(), _createBlock(_component_c_no_data, {
    key: 1
  })) : _createCommentVNode("", true), _createVNode(_component_Overlay, {
    showOverlay: _ctx.showOverlay
  }, null, 8, ["showOverlay"])]);
}